import { useSyncExternalStore } from "react";
import { logout } from "../api/helpers/indee";

/**
 * Generic helper to create a boolean external store
 */
const createBooleanStore = (initialValue = false) => {
  let value = initialValue;
  const listeners = new Set();

  const subscribe = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  };

  const getSnapshot = () => value;

  const setValue = (next) => {
    value = typeof next === "function" ? next(value) : next;
    listeners.forEach((l) => l());
  };

  const useValue = () => useSyncExternalStore(subscribe, getSnapshot);

  return [useValue, setValue];
};

/**
 * Generic external store (string, number, null, etc.)
 */
const createValueStore = (initialValue) => {
  let value = initialValue;
  const listeners = new Set();

  const subscribe = (listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  };

  const getSnapshot = () => value;

  const setValue = (next) => {
    value = typeof next === "function" ? next(value) : next;
    listeners.forEach((l) => l());
  };

  const useValue = () => useSyncExternalStore(subscribe, getSnapshot);

  return [useValue, setValue];
};

/* ─────────────────────────────── */
/*  Export globals */
/* ─────────────────────────────── */

export const [useDisplayScreenerLogin, setDisplayScreenerLogin] =
  createBooleanStore(false);
export const [useDisplayScreenerProjectList, setDisplayScreenerProjectList] =
  createBooleanStore(false);
export const [useAuthActionFlag, setAuthActionFlag] = createBooleanStore(false);
export const [useAuthComplete, setAuthComplete] = createBooleanStore(false);
export const [useSuccess, setSuccess] = createBooleanStore(false);
export const [useScreenerLoggedIn, setScreenerLoggedIn] =
  createBooleanStore(false);
export const [useLoggingOut, setLoggingOut] = createBooleanStore(false);
export const [useIndeeApiChecked, setIndeeApiChecked] =
  createBooleanStore(false);

/* ─────────────────────────────── */
/*  String / nullable globals      */
/* ─────────────────────────────── */

export const [useActiveProjectKey, setActiveProjectKey] =
  createValueStore(null);

export const [useActiveTitleName, setActiveTitleName] = createValueStore(null);
